import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    BreadcrumbEllipsisButtonDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    getHitArea
} from "../../../../helpers/theme/control";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0,
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    surface: {
        justifyContent: "center",
        alignItems: "center"
    }
});

export const useStyles = ({
    isFocusVisible,
    shapeConfigs,
    touchTargets,
    pointerType,
    measures,
    radiuses,
    borders,
    colors
}: BreadcrumbEllipsisButtonDynamicStyleType) => {
    const hitArea = getHitArea({
        visualSize: measures.boxHeight,
        touchTargets,
        pointerType
    });

    const styles = {
        container: {
            marginHorizontal: (measures.iconSize - Math.max(measures.boxHeight, hitArea.minWidth)) / 2,
            minHeight: hitArea.minHeight,
            minWidth: hitArea.minWidth
        } as Mutable<ViewStyle>,
        surface: {
            ...getCornerStyle({
                radius: radiuses.actions,
                shapeConfigs
            }),
            height: measures.boxHeight,
            width: measures.boxHeight
        } as Mutable<ViewStyle>
    };

    Object.assign(styles.surface, getFocusRingStyle({
        colorKey: "default",
        isFocusVisible,
        borders,
        colors
    }));

    return styles;
};
export default stylesheet;
